import React from 'react';
import { Router, Route, browserHistory, IndexRoute } from 'react-router';
import Master from './Master';
import Dashboard from './component/Dashboard';
import Pegawai from './component/Pegawai';
import Addpegawai from './component/Addpegawai';
import Instansi from './component/Instansi';
import Login from './component/auth/Login';
import Updatepegawai from './component/Updatepegawai';
import Sppd from './component/Sppd';
import Attr from './component/Attr';
import Rincian from './component/Rincian';
import Administrator from './component/Administrator';

//
import Pasien from './component/Pasien'
import Icd from './component/Icd'

function Routemain(){
    return(
        <Router history={browserHistory} basename='/rm'>
            <Route path={`${process.env.PUBLIC_URL}/`} component={Login} />
            <Route component={Master}>
                <Route path={`${process.env.PUBLIC_URL}/dashboard`} component={Dashboard} />
                <Route path={`${process.env.PUBLIC_URL}/pegawai`} component={Pegawai} />
                <Route path={`${process.env.PUBLIC_URL}/addpegawai`} component={Addpegawai} />
                <Route path={`${process.env.PUBLIC_URL}/instansi`} component={Instansi} />
                <Route path={`${process.env.PUBLIC_URL}/updatepegawai`} component={Updatepegawai} />
                <Route path={`${process.env.PUBLIC_URL}/sppd`} component={Sppd} />
                <Route path={`${process.env.PUBLIC_URL}/attr`} component={Attr} />
                <Route path={`${process.env.PUBLIC_URL}/administrator`} component={Administrator} />
                <Route path={`${process.env.PUBLIC_URL}/rincian`} component={Rincian} />
                <Route path={`${process.env.PUBLIC_URL}/pasien`} component={Pasien} />
                <Route path={`${process.env.PUBLIC_URL}/icd`} component={Icd} />
            </Route>
        </Router>
    );
}

export default Routemain